import WhyThisResultBox from './WhyThisResultBox';

export default WhyThisResultBox;

export type {
  IWhyThisResultBoxProps,
  IWhyThisResultReason,
  WhyThisResultLevel
} from './WhyThisResultBox';
